export const PlannRoute = (stayPoint, optimize) => {
  return new Promise((resolve, reject) => {
    if($("#gMapAPI").length > 0){
      $("#gMapAPI").remove()
    }
    var mapUrl = sessionStorage.getItem('googleMapUrl')
    const $script = document.createElement('script')
    global.document.body.appendChild($script)
    $script.src = mapUrl
    $script.id = 'gMapAPI'
    // script节点加载成功
    $script.onload = () => {
      $script.onload = null
      // 地图js加载成功
      if (global.google) {
        var sum = [] // 保存每个地点的时间距离
        var waypts = [] // 保存经由地
        var totalDistance = 0// 总路程
        var totalTime = 0// 总时间
        // 循环保存对象
        for (let index = 1; index < stayPoint.length - 1; index++) {
          const point = stayPoint[index]
          waypts.push({
            location: point,
            stopover: true
          })
        }
        var directionsDisplay = new global.google.maps.DirectionsRenderer()
        var directionsService = new global.google.maps.DirectionsService()
        var request = {
          origin: stayPoint[0],
          destination: stayPoint[stayPoint.length - 1],
          waypoints: waypts,
          optimizeWaypoints: optimize,
          travelMode: 'DRIVING'
        }
        directionsService.route(request, function (response, status) {
          if (status === global.google.maps.DirectionsStatus.OK) {
            directionsDisplay.setDirections(response)
            console.log(response['routes'])
            response['routes'][0].legs.forEach(item => {
              var distanceVaue = item.distance.value
              var durationVaue = item.duration.value
              if (distanceVaue / 100 > 1000) {
                distanceVaue = Math.round(distanceVaue / 1000)
              } else {
                distanceVaue = Math.round(distanceVaue / 100) / 10
              }
              durationVaue = Math.round(durationVaue / 60)
              totalDistance += distanceVaue
              totalTime += durationVaue
              sum.push({
                durationText: item.duration.text,
                distanceText: item.distance.text,
                distanceVaue: distanceVaue,
                durationVaue: durationVaue
              })
            })
            sum.push({
              totalDistance: totalDistance,
              totalTime: totalTime,
              order: response['routes'][0].waypoint_order
            })
          }
          // 执行成功
          resolve(sum)
        })
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/utils/planningRoute.js